// Central content + brand assets for the First Impression Property Management landing page.

export const BRAND = {
  name: "First Impression Property Management",
  shortName: "First Impression",
  division: "Property Management",
  tagline: "Managed with care. Maintained to impress.",
  email: "admin@getfirstimpression.com",
  phone: "020 3581 0867",
  phoneHref: "tel:02035810867",
};

export const IMAGES = {
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_hands-off-rent/artifacts/ww0ycn95_3E27BEA7-6B62-4782-89D0-80C175CA20E8.jpeg",
  hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_hands-off-rent/artifacts/ww0ycn95_3E27BEA7-6B62-4782-89D0-80C175CA20E8.jpeg",
  valueProp: "https://images.unsplash.com/photo-1704040686413-2c607dbd2f06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  work1: "https://customer-assets-m6fa6gv7.emergentagent.net/job_hands-off-rent/artifacts/q77ioa5s_IMG_2494.png",
  work2: "https://customer-assets-m6fa6gv7.emergentagent.net/job_hands-off-rent/artifacts/1jih3ani_IMG_2493.png",
  accent: "https://customer-assets-m6fa6gv7.emergentagent.net/job_hands-off-rent/artifacts/ww0ycn95_3E27BEA7-6B62-4782-89D0-80C175CA20E8.jpeg",
  interior: "https://images.unsplash.com/photo-1704040686413-2c607dbd2f06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const BADGES = ["Reliable", "Professional", "Fully Managed"];

export const PACKAGES_INTRO = {
  eyebrow: "Our Services",
  title: "Tailor-Made Holiday Let Services",
  tagline: "Your property. Our responsibility.",
  description: "Whether you simply need your holiday let professionally prepared between guests, or you\u2019d like us to take care of the entire property, we deliver a service tailored precisely to you.",
};

export const PACKAGES = [
  {
    id: "guest-ready",
    tier: "Tier 01",
    name: "Guest Ready",
    subtitle: "Housekeeping & Turnover",
    price: "Custom",
    priceUnit: "per turnover",
    audience: "For owners who manage their own bookings but want the property professionally looked after between every guest.",
    features: [
      "Professional changeover clean",
      "Linen change & bed making",
      "Fresh towels",
      "Bathroom & kitchen sanitisation",
      "Property presentation",
      "Restocking of agreed essentials",
      "Rubbish removal",
      "Basic damage & maintenance reporting",
      "Photographs after each clean (on request)",
      "Key holding",
      "Final guest-ready inspection",
    ],
    extras: [
      "Deep cleans",
      "Oven cleaning",
      "Carpet cleaning",
      "Upholstery cleaning",
      "Window cleaning",
      "Mattress cleaning",
      "Emergency cleans",
      "Garden maintenance",
    ],
    note: "Cleaning charged at a fixed price per turnover, based on property size & requirements.",
    cta: "Get a Quote",
    featured: false,
  },
  {
    id: "premium",
    tier: "Tier 02",
    name: "Premium",
    subtitle: "Holiday Let Management",
    price: "17%",
    priceUnit: "of booking revenue",
    inherits: "Guest Ready",
    audience: "Everything in Guest Ready, plus full platform, guest and performance management.",
    features: [
      "Airbnb, Booking.com & other platform management",
      "Guest communication",
      "Check-in & check-out",
      "Calendar management",
      "Dynamic pricing",
      "Listing optimisation",
      "Review management",
      "Maintenance coordination",
      "Consumables management",
      "Regular property inspections",
      "Damage reporting",
      "Monthly owner statements",
      "Guest issue resolution",
    ],
    note: "Cleaning charged separately per turnover.",
    cta: "Request a Management Proposal",
    featured: true,
  },
  {
    id: "complete",
    tier: "Tier 03",
    name: "Complete",
    subtitle: "Fully Managed Holiday Let",
    price: "22%",
    priceUnit: "of booking revenue",
    inherits: "Premium",
    audience: "Our complete hands-off management service \u2014 for owners who want zero involvement.",
    features: [
      "Complete property oversight",
      "7-day guest support",
      "Regular property inspections",
      "Emergency response",
      "Contractor management",
      "Garden & outdoor maintenance coordination",
      "Linen management",
      "Inventory management",
      "Consumables replenishment",
      "Deep-clean scheduling",
      "Carpet & upholstery maintenance",
      "Property condition reports",
      "Revenue optimisation",
      "Monthly performance reporting",
      "Annual property review",
    ],
    note: "Cleaning charged separately per turnover.",
    cta: "Book a Discovery Call",
    featured: false,
  },
];

export const WHY_CHOOSE = [
  {
    n: "01",
    title: "In-house specialists",
    body: "Our own cleaning & maintenance teams handle both internal and external work \u2014 never unpredictable subcontractors.",
  },
  {
    n: "02",
    title: "Specialist deep cleaning",
    body: "Carpets, upholstery and end-of-season deep cleans delivered directly by a dedicated cleaning company.",
  },
  {
    n: "03",
    title: "Faster, transparent reporting",
    body: "Quicker response times paired with clear photo reporting after every visit.",
  },
  {
    n: "04",
    title: "One point of contact",
    body: "A single dedicated contact who knows your property inside out \u2014 no call-centre roulette.",
  },
  {
    n: "05",
    title: "Tailored packages",
    body: "Bespoke plans for individual owners and portfolio investors alike.",
  },
];

export const STEPS = [
  { n: "01", title: "Free Consultation", body: "Get in touch to discuss your goals and the outcome you want from your property." },
  { n: "02", title: "Property Visit", body: "We inspect the property in person and recommend the tier that fits best." },
  { n: "03", title: "Onboarding", body: "We set up the listing and prepare the home so it\u2019s guest-ready." },
  { n: "04", title: "Hands-Off Management", body: "Relax while we handle the rest \u2014 you stay informed, we stay hands-on." },
];

export const FAQS = [
  {
    q: "Do I have to sign a long-term contract?",
    a: "No \u2014 all three services (Guest Ready, Premium and Complete) run on flexible, rolling agreements. You\u2019re never locked in.",
  },
  {
    q: "Can I use my property for personal stays?",
    a: "Yes \u2014 personal bookings are allowed across all our services. Just block the dates in your calendar and we\u2019ll work around them.",
  },
  {
    q: "How is cleaning priced?",
    a: "Cleaning is charged at a fixed price per turnover, based on your property size and requirements. On Premium and Complete, cleaning is charged separately from the management commission so you always see exactly what you pay for.",
  },
  {
    q: "How is maintenance handled?",
    a: "It\u2019s handled in-house by our maintenance specialists, with full owner visibility on every job and photo reporting where required.",
  },
  {
    q: "Do you provide deep / specialist cleaning?",
    a: "Yes. As a dedicated cleaning company we handle carpet, upholstery, oven, window, mattress and end-of-season deep cleans directly \u2014 available as optional extras on Guest Ready and included in the schedule for Complete.",
  },
];

export const PROPERTY_TYPES = [
  "Holiday Let",
  "Short-term Rental",
  "Buy-to-let / Investment",
  "Portfolio (multiple)",
  "Other",
];

export const PACKAGE_OPTIONS = [
  "Not sure yet",
  "Guest Ready",
  "Premium",
  "Complete",
];
